export enum ScriptType {
    text = 'text',
    audio = 'audio',
    record = 'record',
}
